<script setup lang="ts">
const uspItems = [
  { id: 1, text: 'Actief in heel Nederland' },
  { id: 2, text: 'Gratis & vrijblijvend' },
  { id: 3, text: '100% onafhankelijk' },
  { id: 4, text: 'Bespaar veel kosten' },
]
</script>

<template>
  <div class="border-b border-default py-6">
    <UContainer>
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-2 lg:gap-4 items-center justify-center">
        <div
          v-for="item in uspItems"
          :key="item.id"
          class="flex items-center justify-center md:justify-start"
        >
          <UIcon
            name="i-lucide-check-circle"
            class="text-success size-4 lg:size-5 mr-1.5 flex-shrink-0"
          />
          <span class="text-highlighted font-medium text-sm lg:text-base">{{ item.text }}</span>
        </div>
      </div>
    </UContainer>
  </div>
</template>
